import {
  DEFAULT_RECORD_RESPONSE,
  DEFAULT_SEARCH_RESPONSE,
} from "../pages/LandingPage/constants";
import { getAPIBffBase } from "../utils";
import { getAccessToken } from "./authService";
import {
  CdcmResponse,
  DeleteRecordRequest,
  ReadRecordRequest,
  RecordsSearchFilterRequest,
  SaveRecordRequest,
  SaveUserFavoritesRequest,
} from "../types";
import { getRecordApiHeadersAndEndPoint } from "../pages/LandingPage/helpers";

const BFF_API_URL = getAPIBffBase();

export async function createRecord(
  request: SaveRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "create");

  return fetch(url, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request.record),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function readRecords(
  request: ReadRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "get");

  const requestHeaders = {
    ...headers,
    ...(request.stores ? { stores: request.stores } : {}),
  };

  return fetch(url, {
    method: "GET",
    headers: requestHeaders,
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function readRecord(
  request: ReadRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "read");

  return fetch(`${url}/${request.recordId}`, {
    method: "GET",
    headers,
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function updateRecord(
  request: SaveRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "update");

  return fetch(url, {
    method: "PUT",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request.record),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function deleteRecord(
  request: DeleteRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(
    request,
    "delete-by-criteria",
  );

  return fetch(url, {
    method: "PUT",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request.record),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function deleteById(
  request: DeleteRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "delete");

  return fetch(url, {
    method: "DELETE",
    headers: {
      ...headers,
      "Content-Type": "application/json",
      id: request.recordId as string,
    },
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function searchRecords(
  request: RecordsSearchFilterRequest,
): Promise<CdcmResponse> {
  const { headers } = getRecordApiHeadersAndEndPoint(request, "search");
  const url = `${BFF_API_URL}accounting-setups/search/${request.functionalArea}${request.url}`;

  return fetch(url, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request.body),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_SEARCH_RESPONSE;
    });
}

export async function convertARRecordScheduleType(
  request: SaveRecordRequest,
): Promise<CdcmResponse> {
  const url = `${BFF_API_URL}accounting-setups/ar-conversion/${request.functionalArea}/${request.functionalUnitName}`;
  return fetch(url, {
    method: "POST",
    headers: {
      "x-store-id": request.storeId,
      "x-enterprise-id": request.enterpriseId,
      "Content-Type": "application/json",
      "x-department-name": request.accountName,
      Authorization: `Bearer ${getAccessToken()}`,
    },
    body: JSON.stringify(request.record),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function saveUserFavorites(
  request: SaveUserFavoritesRequest,
): Promise<CdcmResponse> {
  const url = `${BFF_API_URL}functionalUnit/save-user-favorites`;
  return fetch(url, {
    method: "POST",
    headers: {
      "x-store-id": request.storeId,
      "x-enterprise-id": request.enterpriseId,
      "Content-Type": "application/json",
      "x-department-name": request.accountName,
      Authorization: `Bearer ${getAccessToken()}`,
    },
    body: JSON.stringify(request.setupsList),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function batchProcess(
  request: SaveRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "batch-process");

  return fetch(url, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request.record),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}

export async function batchProcessValidate(
  request: SaveRecordRequest,
): Promise<CdcmResponse> {
  const { headers, url } = getRecordApiHeadersAndEndPoint(request, "batch-validate");

  return fetch(url, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request.record),
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
      return DEFAULT_RECORD_RESPONSE;
    });
}
